import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const useShoppingCartSummaryMexico = (shoppingCartData) => {
  const { t } = useTranslation();

  const formattedShoppingCart = useMemo(() => {
    const shoppingCartArray = [
      {
        title: 'Cantidad de facturas',
        subtitle: '',
        value: shoppingCartData?.invoiceCount,
        money: false,
      },
      {
        title: 'Monto total',
        subtitle: '',
        value: shoppingCartData?.totalAmount,
        money: true,
      },
      {
        title: 'Tasa promedio',
        subtitle: '',
        value: shoppingCartData?.rate,
        money: false,
      },
      {
        title: t('Price difference'),
        subtitle: '',
        value: shoppingCartData?.priceDifference,
        money: true,
        discount: true,
      },
      {
        title: t('retention'),
        subtitle: '',
        value: shoppingCartData?.retainedAmount,
        divider: true,
        money: true,
        discount: true,
      },
      {
        title: 'Total a depositar',
        titleVariant: 'small_3',
        valueVariant: 'medium_1',
        subtitle: 'En base a simulación a 30 días.',
        value: shoppingCartData?.depositAmount,
        money: true,
        color: 'primary.main',
      },
    ];

    if (shoppingCartData?.negativeSurplus?.amount > 0) {
      shoppingCartArray.splice(7, 0, {
        title: 'Cobro por mora acumulada',
        value: shoppingCartData?.negativeSurplus,
        money: true,
        // icon: <NegativeSurplusAlertButton />,
      });
    }

    return shoppingCartArray;
  }, [shoppingCartData, t]);

  return formattedShoppingCart;
};

export default useShoppingCartSummaryMexico;
